import { Tooltip } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import { AiFillMinusCircle } from "react-icons/ai";

interface CirculoNegativoProps {
  onClick: () => void;
  size?: number;
  posicaoToolTip?: TooltipPlacement | undefined;
  tituloToolTip?: string;
}

const CirculoSinalNegativo: React.FC<CirculoNegativoProps> = (props) => {
  return (
    <Tooltip title={props.tituloToolTip ? props.tituloToolTip : ""} placement={props.posicaoToolTip}>
      <AiFillMinusCircle
        size={props.size ? props.size : 15}
        onClick={props.onClick}
        className="cursor-pointer"
        color="#a498e7"
      />
    </Tooltip>
  );
};

export default CirculoSinalNegativo;
